<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <el-form :model="value" ref="formRef" :rules="rules">
    <el-row>
      <el-col :lg="12" :sm="12">
        <el-form-item label="连接地址" prop="host" required>
          <el-input v-model="value.host" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="连接端口" prop="port" required>
          <el-input v-model="value.port" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="连接用户名" prop="username" required>
          <el-input v-model="value.username" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="连接密码" prop="password" required>
          <el-input v-model="value.password" show-password/>
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="虚拟主机名称(Vhost)" prop="vhost" required>
          <el-input v-model="value.vhost" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="是否使用SSL加密" prop="ssl" required>
          <el-select v-model="value.ssl" placeholder="请选择" default-first-option>
            <el-option
              v-for="item in rabbitMQssl"
              :key="item.value"
              :label="item.label"
              :value="item.value" >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="交换器名称" prop="exchange">
          <el-input v-model="value.exchange" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :sm="12">
        <el-form-item label="路由键名称" prop="routingkey">
          <el-input v-model="value.routingkey" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-col :lg="24" :sm="12">
      <el-form-item label="发送至节点队列名称" prop="outqueue" required>
        <el-input v-model="value.outqueue" />
      </el-form-item>
    </el-col>
    <el-col :lg="24" :sm="12">
      <el-form-item label="从节点接收队列名称" prop="inqueue" required>
        <el-input v-model="value.inqueue" />
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  import CommonValidate from "@/libs/Validate";

  export default {
    name: "RabbitMQConfig",
    components: {},
    computed: {},
    props:{
      value:{
        ssl:false
      }
    },
    data() {
      return {
        rabbitMQssl: [{
          value: false,
          label: '否'
        }, {
          value: true,
          label: '是'
        }],
        rules: {
          host: [{ required: true, message: "这是必填字段" },{min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          port: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          vhost: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          username: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          password: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 30, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
          ssl: [{ required: true, message: "这是必填字段" }],
          outqueue: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 50, message: "长度在 1 到 50 个字符以内", trigger: "blur"}],
          inqueue: [{ required: true, message: "这是必填字段" },
            {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
            {min: 1, max: 50, message: "长度在 1 到 50 个字符以内", trigger: "blur"}],

        },
      };
    },
    async mounted() {
    },
    created() {
      this.value.ssl = false;
    },
    methods: {
      validate() {
        return this.$refs.formRef.validate();
      },
      checkNumber(){

      }
    },
  };
</script>
